let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("inz58")]).then(() => parcelRequire('j8S4j'));